import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { CustomTableComponent } from './custom-table.component';
import { TestingComponent } from './testing.component';
//import { MatMenuModule } from '@angular/material/menu';
//import { MatButtonModule } from '@angular/material/button';
//import { MatIconModule } from '@angular/material/icon';
//import { MatListModule } from '@angular/material/list';
//import { MatTableModule } from '@angular/material/table';
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomTableRoutingModule } from './custom-table-routing.module';
//import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
//import { DynamicMatTableModule } from 'dynamic-mat-table';
//import { MatStepperModule } from '@angular/material/stepper';

 
@NgModule({
    declarations: [ 
        //CustomTableComponent, 
        TestingComponent ],
    imports: [
        CommonModule,
        CustomTableRoutingModule,
        NgbDropdownModule, NgbPaginationModule,
   //     MatMenuModule, MatButtonModule, MatIconModule, MatListModule, MatTableModule,
    //    NgMultiSelectDropDownModule.forRoot(),
    //    DynamicMatTableModule,
    //    MatStepperModule
    ],
    providers: [],
    exports: [ 
        //CustomTableComponent,
        TestingComponent ]
})

export class CustomTableModule {}